import React, { createContext, useContext, useEffect, useState } from "react";
import backendUrl from "../backendUrl";
import fetchApi from "../fetchApi";

const AuthContext = createContext();
export default AuthContext;

export const useAuth = () => useContext(AuthContext);

export const AuthContextProvider = ({ children }) => {
  const [authState, setAuthState] = useState();
  const [user, setUser] = useState();

  // Login - Get access token from backend and store it locally
  const login = async (username, password) => {
    const options = {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    };
    try {
      const rawResult = await fetch(
        `${backendUrl}/wp-json/jwt-auth/v1/token`,
        options
      );
      const result = await rawResult.json();
      if (result.token) {
        setAuthState(result);
        localStorage.setItem("authState", JSON.stringify(result));
        return null;
      } else throw result;
    } catch (error) {
      console.error(error);
      return error;
    }
  };

  // Logout - Remove local access token, clean states and reload to home page
  const logout = async () => {
    localStorage.removeItem("authState");
    setAuthState(null);
    setUser(null);
    window.location.href = "/";
  };

  const fetchUser = async () => {
    if (authState) {
      const [fetchedUser] = await fetchApi(
        `/users?slug=${authState.user_nicename}`
      );
      setUser(fetchedUser);
    }
  };

  // On page load, check stored access token and retrieve current authentication if exists
  useEffect(() => {
    const validate = async () => {
      const storedAuthState = JSON.parse(localStorage.getItem("authState"));
      if (!storedAuthState) return;
      const options = {
        method: "post",
        headers: {
          Authorization: `Bearer ${storedAuthState.token}`,
        },
      };
      try {
        const rawResult = await fetch(
          `${backendUrl}/wp-json/jwt-auth/v1/token/validate`,
          options
        );
        const result = await rawResult.json();
        if (result.data && result.data.status === 200) {
          console.log("Stored AuthState is valid");
          setAuthState(storedAuthState);
        } else {
          throw new Error(
            "Incorrect response from /wp-json/jwt-auth/v1/validate"
          );
        }
      } catch (error) {
        console.error(error);
        localStorage.removeItem("authState");
      }
    };
    validate();
  }, []);

  // When user is authenticated, fetch his data from backend
  useEffect(() => {
    if (authState) fetchUser();
  }, [authState]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AuthContext.Provider
      value={{ authState, user, setUser, fetchUser, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
